import { render, staticRenderFns } from "./AboutUsComponent.vue?vue&type=template&id=64d989a1&lang=pug&"
import script from "./AboutUsComponent.vue?vue&type=script&lang=js&"
export * from "./AboutUsComponent.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsComponent.vue?vue&type=style&index=0&id=64d989a1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports